import ToggleInput from './ToggleInput.vue';

export default ToggleInput;
